import { QuantumProvider, QuantumProviderValue } from '@quantum/tools/context';
import { useNavigate } from 'react-router-dom';
import React from 'react';

const hideLoader = () => {
  if (window.globalLoaderEnabled) {
    window.hideLoader();
  }
};
const showLoader = () => {
  if (window.globalLoaderEnabled) {
    window.showLoader();
  }
};
interface QuantumProviderWrapperProps {
  children: React.ReactNode;
  value: QuantumProviderValue;
}

export const QuantumProviderWrapper = ({ children, value }: QuantumProviderWrapperProps) => {
  const navigate = useNavigate();
  return <QuantumProvider value={{ ...value, showLoader, hideLoader, navigate }}>{children}</QuantumProvider>;
};
